import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { KAILAC_WHATSAPP_NUMBER } from '@/config/contactPhone';

const WA_MESSAGE_EN = 'Hi! I found Kailac and I\'d like to learn more about 0% interest business funding.';
const WA_MESSAGE_ES = '¡Hola! Encontré Kailac y me gustaría saber más sobre el financiamiento empresarial al 0% de interés.';

export default function FloatingWhatsApp() {
  const { t } = useTranslation();
  const location = useLocation();
  const [showTooltip, setShowTooltip] = useState(false);

  // Hide on contact page since it already has WhatsApp integration
  const isContactPage =
    location.pathname === '/contact' || location.pathname === '/es/contacto';
  if (isContactPage) return null;

  const isEs = location.pathname.startsWith('/es');
  const message = isEs ? WA_MESSAGE_ES : WA_MESSAGE_EN;
  const waUrl = `https://wa.me/${KAILAC_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="nofollow noreferrer"
      aria-label={t('wa_floating_tooltip')}
      className="fixed right-5 bottom-24 lg:bottom-8 z-40 flex items-center gap-2 group cursor-pointer"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {/* Tooltip */}
      <div
        className={`absolute right-full mr-3 px-3 py-2 rounded-xl bg-gray-900 text-white text-xs font-medium whitespace-nowrap
          transition-all duration-200 pointer-events-none
          ${showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2'}`}
      >
        {t('wa_floating_tooltip')}
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900" />
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] hover:bg-[#20BA5A] transition-all duration-200 hover:scale-105">
        {/* Pulse ring */}
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <i className="ri-whatsapp-line text-white text-2xl relative z-10"></i>
      </div>
    </a>
  );
}
